import { useGridApiRef } from '@mui/x-data-grid-premium';
import { MutableRefObject, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomGridApi } from '../components/common/XTable/types';
import { PageNameType } from '../redux/clientConfiguration/clientConfigurationSlice';
import { CommonState } from '../redux/_common/commonReducers';
import { getBaseDomain } from '../redux/pageDomain';
import reduxSlicesList from '../redux/reduxSlicesList';
import { RootState } from '../redux/store';
import { setConfigStorageItem } from './useConfigStorage';

type TablePageName = Extract<PageNameType, keyof typeof reduxSlicesList>;

const useTablePage = (pageName: TablePageName) => {
 const apiRef = useGridApiRef() as MutableRefObject<CustomGridApi>;

 const dispatch = useDispatch();

 const selector = useSelector<RootState, CommonState>(
  (state) => state[getBaseDomain(pageName)] as unknown as CommonState,
 );

 const { items, rowCount, loading, success } = selector;

 useEffect(() => {
 const getTableStructureStartAction = reduxSlicesList[pageName]?.getTableStructureStart;
 if (!getTableStructureStartAction) {
  return;
 }
 dispatch(
  getTableStructureStartAction({
   table: pageName,
  }),
 );

  // this loads current preset
 }, [dispatch, pageName]);

 useEffect(() => {
  if (
   selector.success.deleteItems ||
   selector.success.deleteItem ||
   selector.success.approveResult ||
   selector.success.updateItem ||
   selector.success.createItem
  ) {
   console.log('useTablePage ue', selector.success);
   apiRef.current.fetchData();
   // reset selected rows
   apiRef.current.setRowSelectionModel([]);
  }
 }, [selector.success, apiRef]);

 useEffect(() => {
  //   console.log(selector.success);
  // why is this needed?
  if (selector.success.getTableStructure) {
   setConfigStorageItem({
    page: pageName, // 'results'
    key: 'structure',
    value: selector.structure,
   });
  }
 }, [selector.success, selector.structure]);

 return { apiRef, items, rowCount, loading, dispatch, success };
};

export default useTablePage;

